import { createSxStyles } from "@common/createSxStyles";

export const tasksWidgetStyles = createSxStyles({
    content: { display: "flex", flexDirection: "column", gap: 2, height: "100%" },
    listWithLink: { display: "flex", flexDirection: "column", flex: 1, minHeight: 0 },
    list: {
        marginRight: `-15px`,
        height: "100%",
        "& .MuiPaper-root": {
            boxShadow: "none",
        },
    },
});
